import { useEffect, useState } from "react";
import { loadSchema } from "./lazy";
import { RegistryItem } from "./schema";
import { AgreementTypeEnum } from "__generated__/graphql";

type SchemaItem = NonNullable<RegistryItem[AgreementTypeEnum]>;

export function useSchema(type: AgreementTypeEnum | null): SchemaItem | null {
	const [ schema, setSchema ] = useState<SchemaItem | null>(null);

	useEffect(() => {
		if (type == null) {
			setSchema(null);
			return;
		}

		loadSchema(type).then((item) => {
			setSchema(item ?? null);
		}).catch(() => {
			setSchema(null);
		});

	}, [ type ]);

	return schema;
}
